module.exports = __webpack_public_path__ + "static/img/B摄像头.db904d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/360°全景环视系统/B摄像头.png
// module id = DoVh
// module chunks = 0